import { useQuery } from '@tanstack/react-query';
import { fetchProject } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useProject = () =>
  useQuery({
    queryFn: () => extractData(fetchProject()),
    queryKey: [''],
    select: (data) => data.project,
  });
